import { gql } from "@apollo/client";

export const GET_PENDING_USER_TEAM_INVITES = gql`
  query pendingUserTeamInvites {
    pendingUserTeamInvites {
      uuid
      timeSent
      team {
        uuid
        name
      }
      sender {
        uuid
        firstName
        lastName
      }
    }
  }
`;
